<template>
  <!-- Sidebar -->

  <v-card class="sidebar-menu">
    <v-navigation-drawer
      v-model="drawer"
      :mini-variant.sync="mini"
      permanent
      disable-resize-watcher
    >
      <v-list-item>
        <router-link to="/pages/flight/flightReservationMonitor" style="text-align:center">
          <img class="sidebar-logo mt-5" src="../images/nova_avia_logo.png" />
        </router-link>
        <v-btn
          color="white"
          icon
          @click.stop="mini = !mini"
          style="margin-right:-20px"
        >
          <img style="width:20px" src="../images/curved-arrow.png" />
        </v-btn>
      </v-list-item>

      <v-list>
        <router-link to="/pages/flight/flightReservationMonitor">
          <v-list-item>
            <v-list-item-icon>
              <i class="fas fa-fw fa-list-alt"></i>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>REZERVASYON</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </router-link>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>



<script>
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class SideBarMenu extends Vue {
  data() {
    return {
      drawer: false,
      mini: false,
    };
  }
}
</script>

<style scoped>
.sidebar-logo {
  width: 80%;
}

::v-deep .theme--light.v-navigation-drawer {
  background-image: linear-gradient(180deg, #23376d 10%, #5bbde6 100%);
}

.v-sheet.v-card {
  border-radius: 0px;
}

.v-list-item .v-list-item__title {
  line-height: 1.2;
  color: white;
  font-size: 14px;
}

.v-list-item__icon:first-child {
  margin-right: 20px !important;
  font-size: 18px;
  color: white;
}

::v-deep
  .v-list-group
  .v-list-group__header
  .v-list-item__icon.v-list-group__header__append-icon
  i {
  color: white;
}

a:hover {
  text-decoration: none !important;
}

@media only screen and (max-width: 992px) {
  .sidebar-menu {
    display: none;
  }
}
</style>
